import React from 'react';
import { Form, Field } from 'react-final-form';
import { FormGroup, Button, ButtonToolbar, ControlLabel } from 'react-bootstrap';
// Features are exported from database ./manage.py export_features
import options from './features.json';

// const options = [{
//   name: 'General',
//   features:
//   [
//
//     { key: 'meetingbanquet-facilities', display: 'Meeting/Banquet facilities' },
//     { key: 'cribs-available', display: 'Cribs available' },
//   ],
//   },
//   { name: 'Services',
//   features:
//   [
//     { key: 'complimentary-breakfast', display: 'Complimentary breakfast' },
//   ],
//   },
// ];
//component="input"
//type="checkbox"
const RenderFeature = ({ value, display }) => (
  <FormGroup>
    <Field name="features" component="input" type="checkbox" value={value} />
    <ControlLabel>{display}</ControlLabel>
  </FormGroup>
);

const RenderCategory = ({ name, features }) => {
  const category = [];
  features.forEach(feature => {
    category.push(
      <RenderFeature key={feature.key} value={feature.key} display={feature.display} />
    );
  });
  return (
    <div className="col-md-4" key={name}>
      <h3>{name}</h3>
      {category}
    </div>
  );
};

const RenderFeatures = ({ options }) => {
  const category = [];
  options.forEach(cat => {
    category.push(<RenderCategory key={cat.name} name={cat.name} features={cat.features} />);
  });
  return <div className="row">{category}</div>;
};

const PropertyFeaturesForm = ({ onSubmit, initialValues, handleClose }) => (
  <Form
    onSubmit={onSubmit}
    initialValues={initialValues}
    render={({ handleSubmit, form, submitting, pristine, values, errors }) => (
      <div className="row">
        <div className="col-md-12">
          <h1 className="hotel-detail-subhead">
            Amenities <Button onClick={handleClose}>Cancel</Button>
          </h1>
          <form onSubmit={handleSubmit}>
            <RenderFeatures options={options} />
            <div className="row">
              <div className="col-md-12">
                {errors.FORM_ERROR && <p className="alert alert-danger">{errors.FORM_ERROR}</p>}
                {errors.note && <p className="alert alert-danger">{errors.note}</p>}
                <FormGroup>
                  <ButtonToolbar>
                    <Button disabled={pristine || submitting} bsStyle="success" type="submit">
                      <i className="fa fa-pencil fa-lg" /> Save
                    </Button>
                    <Button disabled={submitting} bsStyle="success" onClick={handleClose}>
                      <i className="fa fa-trash fa-lg" /> Cancel
                    </Button>
                  </ButtonToolbar>
                </FormGroup>
              </div>
            </div>
          </form>
        </div>
      </div>
    )}
  />
);

export default PropertyFeaturesForm;


// WEBPACK FOOTER //
// src/routes/hotels/components/PropertyFeaturesForm.js